var requireSvg = require.context('!raw-loader!svgo-loader?{"plugins":[{"removeTitle":true}]}!../img/', false, /\.svg$/)

export default function (name) {
  return requireSvg(`./${name}.svg`)
}



// WEBPACK FOOTER //
// ./resources/assets/js/svg.js